import { useState } from "react";
import { FileUploader } from "react-drag-drop-files";
import SrvButtonLink from "../global/SrvButtonLink";

function WidgetFile({ files, setFiles }) {

    const [log, setLog] = useState(null);


    //Событие выбора файла
    function changeFileHandler(data) {
        if (data.length > 0) {
            const count = files.length;

            const fileMass = Array.from(data).map((item, index) => {
                const ext = item.name.split('.').pop();
                const name = item.name.replace('.' + ext, '');

                return {
                    Name: name,
                    Path: item.name,
                    File: data[index],
                    Size: item.size
                }
            })
            setFiles([...files, ...fileMass]);
        }
    }

    //Событие удаления файла
    function changeRemoveHandler(index) {
        setFiles(files.filter((q, ind) => ind !== index))
    }

    return (
        <>
            <FileUploader handleChange={(files) => changeFileHandler(files)} multiple={true} label={'Выберите файлы'} maxSize={28} onSizeError={() => setLog("Превышен максимальный размер 1 файла 28мб")} onSelect={() => setLog(null)} />
            {log !== null && (<div className="form_error">{log}</div>)}
            <div className="mt-15">
                {
                    files.map((file, index) => (
                        <div key={index} className="row_select" style={{ display: "flex" }}>
                            <div  >{file.Path}</div>
                            <div style={{ marginLeft: "auto" }}> <SrvButtonLink typeBtn="remove" textBtn="" onClick={() => changeRemoveHandler(index)} /></div>
                        </div>
                    ))
                }
            </div>
        </>
    )
}

export default WidgetFile;